// Hardcoded for now

export interface BankConfig {
  externalId: string
  multiple: boolean
  searchTerm: string
}

const deConfig: BankConfig[] = [
  {
    externalId: 'DE_N26',
    multiple: false,
    searchTerm: 'N26',
  },
  {
    externalId: 'DE_Commerzbank',
    multiple: false,
    searchTerm: 'Commerzbank',
  },
  {
    externalId: 'DE_DeutscheKreditBank',
    multiple: false,
    searchTerm: 'Deutsche Kreditbank',
  },
  {
    externalId: 'DE_Revolut',
    multiple: false,
    searchTerm: 'Revolut',
  },
  {
    externalId: 'DE_Ing',
    multiple: false,
    searchTerm: 'ING',
  },
  {
    externalId: 'DE_VrSudBank',
    multiple: true,
    searchTerm: 'Volks und raiffeisen',
  },
  { externalId: 'DE_DeutscheBank', multiple: false, searchTerm: 'Deutsche Bank' },
  {
    externalId: 'DE_LandesbankSaar',
    multiple: true,
    searchTerm: 'Sparkasse',
  },
  {
    externalId: 'DE_PsdBankKoblenz',
    multiple: true,
    searchTerm: 'PSD Bank',
  },
]

const dkConfig: BankConfig[] = [
  {
    externalId: 'DK_DanskeBank',
    multiple: true,
    searchTerm: 'Danske Bank',
  },
  {
    externalId: 'DK_Nordea',
    multiple: true,
    searchTerm: 'Nordea',
  },
  {
    externalId: 'DK_Nykredit',
    multiple: false,
    searchTerm: 'Nykredit',
  },
  {
    externalId: 'DK_JyskeBankErhverv',
    multiple: false,
    searchTerm: 'Jyske Bank Erhverv',
  },
  {
    externalId: 'DK_Sydbank',
    multiple: true,
    searchTerm: 'Sydbank',
  },
  {
    externalId: 'DK_LunarWay',
    multiple: false,
    searchTerm: 'Lunar Way',
  },
  {
    externalId: 'DK_ArbejdernesLandsbank',
    multiple: false,
    searchTerm: 'Arbejdernes Landsbank',
  },
  {
    externalId: 'DK_SparekassenVendsyssel',
    multiple: true,
    searchTerm: 'Sparekassen',
  },
  {
    externalId: 'DK_Revolut',
    multiple: false,
    searchTerm: 'Revolut',
  },
]

const frConfig: BankConfig[] = [
  {
    externalId: 'FR_CreditMutuel',
    multiple: true,
    searchTerm: 'Crédit Mutuel',
  },
  {
    externalId: 'FR_Lcl',
    multiple: false,
    searchTerm: 'LCL',
  },
  {
    externalId: 'FR_SocieteGeneraleEnterprise',
    multiple: true,
    searchTerm: 'Société Générale',
  },
  {
    externalId: 'FR_Cic',
    multiple: false,
    searchTerm: 'CIC',
  },
  {
    externalId: 'FR_Mabanque',
    multiple: true,
    searchTerm: 'BNP Paribas',
  },
  {
    externalId: 'FR_Revolut',
    multiple: false,
    searchTerm: 'Revolut',
  },
  {
    externalId: 'FR_LaBanquePostale',
    multiple: false,
    searchTerm: 'La Banque Postale',
  },
  {
    externalId: 'FR_CreditCooperatif',
    multiple: false,
    searchTerm: 'Crédit Coopératif',
  },
  {
    externalId: 'FR_N26',
    multiple: false,
    searchTerm: 'N26',
  },
]

const nlConfig: BankConfig[] = [
  {
    externalId: 'NL_AbnAmro',
    multiple: false,
    searchTerm: 'ABN AMRO',
  },
  {
    externalId: 'NL_Ing',
    multiple: false,
    searchTerm: 'ING',
  },
  {
    externalId: 'NL_N26',
    multiple: false,
    searchTerm: 'N26',
  },
  {
    externalId: 'NL_Rabobank',
    multiple: false,
    searchTerm: 'Rabobank',
  },
  {
    externalId: 'NL_Bunq',
    multiple: false,
    searchTerm: 'Bunq',
  },
  {
    externalId: 'NL_Revolut',
    multiple: false,
    searchTerm: 'Revolut',
  },
]

export const popularBanksPerCountry: Record<string, BankConfig[]> = {
  DE: deConfig,
  DK: dkConfig,
  FR: frConfig,
  NL: nlConfig,
}
